module.exports = __webpack_public_path__ + "media/performance/eye-check-c66ac643.svg";